module.exports = __webpack_public_path__ + "media/50d.dd9c4f11.mp4";